<template>
  <div id="sidebar-menu">
    <ul
      class="navbar-nav sidebar sidebar-light accordion mb-8"
      id="accordionSidebar"
      v-if="HeadTableFlag"
    >
      <!-- <a
        class="sidebar-brand d-flex align-items-center justify-content-center"
        href="index.html"
      >
        <div class="sidebar-brand-icon">
          <img src="img/logo/logo2.png" />
        </div>
        <div class="sidebar-brand-text mx-3">JCI INDIA AWARDS</div>
      </a> -->
      <div
        class="sidebar-brand d-flex align-items-center justify-content-center"
      >
        <div class="sidebar-brand-icon">
          <img :src="Logo" alt="jci-logo" />
        </div>
        <!-- <div class="sidebar-brand-text mx-3">JCI INDIA AWARDS</div> -->
      </div>
      <li class="nav-item mt-3 text-center">
        <h6 v-if="RoleId == 174">
          Zone Awards <br />
          <span style="color: blueviolet"> {{ ZoneDisplayText }} </span>
        </h6>
        <h6 v-if="RoleId == 175">National Awards</h6>
      </li>
      <hr class="sidebar-divider" v-if="RoleId == 196" />
      <div class="sidebar-heading" id="head" v-if="RoleId == 196">For EO</div>
      <li class="nav-item ml-2" v-if="RoleId == 196">
        <router-link to="/zone-directory-information/list" class="nav-link">
          <v-icon icon size="25px"> mdi mdi-seal </v-icon>
          <span id="menu">Zone Directory Information </span>
        </router-link>
      </li>
      <hr class="sidebar-divider" />
      <div class="sidebar-heading" id="head">Judges</div>
      <li class="nav-item ml-2">
        <router-link to="/judges/list" class="nav-link">
          <v-icon icon size="25px"> mdi-account-group-outline </v-icon>
          <span id="menu">Judges List</span>
        </router-link>
      </li>
      <hr class="sidebar-divider" />
      <div class="sidebar-heading mt-4" id="head">Judges Awards Mapping</div>
      <li class="nav-item ml-2">
        <router-link to="/awards-mapping/not-mapped" class="nav-link">
          <v-icon icon size="25px"> mdi mdi-close-network </v-icon>
          <span id="menu">Not Mapped Awards</span>
        </router-link>
      </li>
      <li class="nav-item ml-2">
        <router-link to="/awards-mapping/mapped-by-awards" class="nav-link">
          <v-icon icon size="25px"> mdi mdi-sitemap </v-icon>
          <span id="menu">Mapped By Awards</span>
        </router-link>
      </li>
      <li class="nav-item ml-2">
        <router-link to="/awards-mapping/mapped-by-judges" class="nav-link">
          <v-icon icon size="25px"> mdi mdi-account-switch </v-icon>
          <span id="menu">Mapped By Judges</span>
        </router-link>
      </li>
      <hr class="sidebar-divider" />
      <div class="sidebar-heading mt-4" id="head">Awards</div>
      <li class="nav-item ml-2">
        <router-link to="/individual-awards/list" class="nav-link">
          <v-icon icon size="25px"> mdi mdi-seal </v-icon>
          <span id="menu">Group I - Individual Awards List</span>
        </router-link>
      </li>
      <li class="nav-item ml-2">
        <router-link to="/lo-awards/list" class="nav-link">
          <v-icon icon size="25px"> mdi mdi-seal </v-icon>
          <span id="menu">Group II - LO Awards List</span>
        </router-link>
      </li>
      <li class="nav-item ml-2">
        <router-link to="/officers-awards/list" class="nav-link">
          <v-icon icon size="25px"> mdi mdi-seal </v-icon>
          <span id="menu">Group III A - Officers Awards List</span>
        </router-link>
      </li>
      <li class="nav-item ml-2">
        <router-link to="/vice-president-awards/list" class="nav-link">
          <v-icon icon size="25px"> mdi mdi-seal </v-icon>
          <span id="menu">Group III B - Vice President Awards List</span>
        </router-link>
      </li>
      <div class="mt-5"></div>
      <div class="version" id="version-ruangadmin"></div>
    </ul>
    <ul
      class="navbar-nav sidebar sidebar-light accordion"
      id="accordionSidebar"
      v-else
    >
      <div
        class="sidebar-brand d-flex align-items-center justify-content-center"
      >
        <div class="sidebar-brand-icon">
          <img :src="Logo" alt="jci-logo" />
        </div>
        <!-- <div class="sidebar-brand-text mx-3">JCI INDIA AWARDS</div> -->
      </div>
      <div class="sidebar-heading mt-4" id="head">Awards</div>
      <li class="nav-item ml-2">
        <router-link to="/awards/list" class="nav-link">
          <v-icon icon size="25px"> mdi mdi-seal </v-icon>
          <span id="menu">Awards List</span>
        </router-link>
      </li>
      <div class="version" id="version-ruangadmin"></div>
    </ul>
  </div>
</template>

<script>
import common from "@/Common.vue";
import companyConfig from "@/company_config.json";

export default {
  mixins: [common],
  components: {},
  data() {
    return {
      RoleId: "",
      Logo: "",
      ZoneDisplayText: "",

      JudgeFlag: false,
      HeadTableFlag: false,
    };
  },
  watch: {},
  methods: {},
  beforeMount() {
    var roleId = this.$session.get("RoleId");
    roleId = roleId == (null || undefined) ? "" : roleId;
    this.RoleId = roleId;
    var JudgeFlag = roleId == 173 ? true : false;
    console.log({ JudgeFlag });
    this.JudgeFlag = JudgeFlag;
    this.HeadTableFlag = JudgeFlag ? false : true;

    var zone = this.$session.get("ZoneDisplayText");
    zone = zone == (null || undefined) ? "" : zone;
    this.ZoneDisplayText = zone;

    console.log({ zone });

    var server_url = companyConfig.apiURL;
    this.Logo = server_url + "assets/images/logo.png";
  },
};
</script>

<style lang="scss" scoped>
#sidebar-menu {
  #head {
    color: blue;
  }
  #menu {
    color: black;
  }
  // .v-icon {
  //   color: black;
  // }
}
</style>